import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIntegrationOpendental = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 26,
	viewBox: "0 0 24 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1899",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.6899 2.31201C8.00878 2.31201 3.38 7.10522 3.38 12.9755C3.38 18.8457 8.00878 23.6389 13.6899 23.6389C19.3711 23.6389 23.9998 18.8457 23.9998 12.9755C23.9998 7.10522 19.3711 2.31201 13.6899 2.31201ZM13.8297 20.712C9.74354 20.712 6.40556 17.2507 6.40556 13.0001C6.40556 8.74954 9.74354 5.28824 13.8297 5.28824C17.9158 5.28824 21.2538 8.74954 21.2538 13.0001C21.2538 17.2507 17.9158 20.712 13.8297 20.712Z",
			fill: "#1D1D30"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.6727 24.4198C7.60512 24.4198 2.65571 19.2895 2.65571 13C2.65571 6.71045 7.60512 1.58016 13.6727 1.58016C18.3754 1.58016 22.404 4.66327 23.9826 8.97962C22.3465 3.93977 17.7342 0.289368 12.3079 0.289368C5.53327 0.289368 0.00012207 6.00339 0.00012207 13C0.00012207 19.9966 5.53327 25.7106 12.3079 25.7106C17.7259 25.7106 22.3465 22.0602 23.9826 17.0204C22.404 21.3367 18.3754 24.4198 13.6727 24.4198Z",
			fill: "#7A7A99"
		})]
	})
});
export default SvgIconIntegrationOpendental;
